
import { isArray } from 'lodash-es';
import AjaxLoader from "../utilities/ajax-loader";

export default class ScheduleBoardService {
  constructor() {
    this.queryParams = [];
    this.enableAjaxLoader = true;
    this.domain = '/admin/components/schedule-board';
  }

  static newInstance() {
    return new ScheduleBoardService();
  }

  radio() {
    this.queryParams.push('t=r');
    return this;
  }

  checkbox() {
    this.queryParams.push('t=c');
    return this;
  }

  inputName(name) {
    this.queryParams.push(`input_name=${name}`);
    return this;
  }

  weekDay(weekDay) {
    this.queryParams.push(`week_day=${weekDay}`);
    return this;
  }

  activity(activityId) {
    this.queryParams.push(`activity=${activityId}`);
    return this;
  }

  notBatchScheduleIds(notBatchScheduleIds) {
    if (!isArray(notBatchScheduleIds))
      return this;

    notBatchScheduleIds.forEach((it) => this.queryParams.push(`not_batch_schedule_ids[]=${it}`));
    return this;
  }

  enrollment(enrollmentId) {
    this.queryParams.push(`enrollment=${enrollmentId}`);
    return this;
  }

  clear() {
    this.queryParams = [];
    return this;
  }

  disableAjaxLoader() {
    this.enableAjaxLoader = false;
    return this;
  }

  enableAjaxLoader() {
    this.enableAjaxLoader = true;
    return this;
  }

  showFilter() {
    this.queryParams.push(`show_filter=1`);
    return this;
  }

  call() {
    !!this.enableAjaxLoader && AjaxLoader.show();

    return new Promise((resolve, reject) => {
      fetch(this.buildUrl(), {
        mode: 'no-cors',
        method: 'get'
      })
        .then((resp) => {
          AjaxLoader.hide();
          return resp.text();
        })
        .then((response) => resolve(response))
        .catch((error) => reject(error))
    });
  }

  buildUrl() {
    return `${this.domain}/?${this.queryParams.join('&')}`;
  }
}